import { useEffect, useState } from "react"; 
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { FieldFilterType } from "../../../../base/types";
import { useGetAssessment } from "./useGetAssessment";

export const useGetExaminerScore = () => {
    const { user, siteId } = useAuth();
    const [getRecords] = useLazyReadMultipleQuery();
    const [examinerScore, setExaminerScore] = useState<string | null>(null);
    const { assessments } = useGetAssessment();

    useEffect(() => {
        if (assessments.length > 0) {
            getExaminerScore();
        }
        // eslint-disable-next-line
    }, [assessments]);

    const getExaminerScore = async (): Promise<void> => {
        if (!user?.contactId) {
            console.error('User contact not found.');
            return;
        }
console.log("assessments", assessments);
        for (const assessment of assessments) {
            try {
                const data = await getRecords({
                    userId: user?.contactId || '',
                    portalId: siteId || '',
                    tableId: "slcm_examinerscore",
                    fieldList: ["slcm_examinerscoreid", "slcm_student","slcm_academicsession", "slcm_exam", "slcm_course"],
                    filters: [{
                        group: 0, filters: [
                            { field: "slcm_student", type: FieldFilterType.Const, value: user?.contactId || '' },
                            { field: "slcm_academicsession", type: FieldFilterType.Const, value: assessment.academicSession },
                            { field: "slcm_exam", type: FieldFilterType.Const, value: assessment.assessmentId || ''},
                            { field: "slcm_course", type: FieldFilterType.Const, value: assessment.courseId }
                        ]
                    }]
                }).unwrap();

                if (data.records.length > 0) {
                    const score = data.records[0]["slcm_examinerscoreid"];
                    
                    // Convert score to string if it's an object
                    setExaminerScore(typeof score === 'object' ? JSON.stringify(score) : String(score));
                    return;
                }
            } catch (error) {
                console.error('Error fetching examiner score:', error);
            }
        }
    };

    return { examinerScore };
};
